<template>
  <div>
    <v-btn color="secondary" class="my-3" @click="dialog = true">
      Proceed
    </v-btn>
    <v-dialog v-model="dialog" max-width="630px">
      <v-card class="tw-py-3 md:tw-py-6">
        <v-card-text>
          <h3 class="tw-text-xl md:tw-text-2xl c-blue-text title-font tw-text-center">Would you like the following additional benefits to come with that?</h3>
          <v-container class="tw-mt-2 md:tw-mt-4">
            <div class="tw-flex tw-items-center">
              <v-icon size="60" color="primary" class="tw--mt-6">mdi-hospital-box-outline</v-icon>
              <div class="tw-px-0 md:tw-px-4">
                <h5 class="w-full c-navy-text tw-text-xl tw-font-bold">Maternity</h5>
                <p class="tw-py-2 tw-text-sm">This covers costs associated with pregnancy, childbirth and their related
              complications (For female principals and female spouses only).</p>
              </div>
            </div>
            <div class="tw-flex tw-items-center">
              <v-icon size="60" color="primary" class="tw--mt-6">mdi-thermometer-lines</v-icon>
              <div class="tw-px-0 md:tw-px-4">
                <h5 class="w-full c-navy-text tw-text-xl tw-font-bold">Outpatient</h5>
                <p class="tw-py-2 tw-text-sm">This covers costs for a patient who is not hospitalised overnight but who
              visits a medical provider for treatment.</p>
              </div>
            </div>
            <div class="tw-flex tw-items-center tw-space-x-4 tw-justify-center">
              <v-btn color="default"  @click="proceed(false)"><span class="c-blue-text">No Thanks</span></v-btn>
              <v-btn color="secondary" @click="proceed(true)">Yes</v-btn>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdditionalBenefits',
  props: ['isEdit'],
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    proceed(yes) {
      if (this.isEdit && !yes) {
        this.dialog = false;
        this.$root.$emit('health-edit-modal-closed');
        return;
      }
      this.$root.$emit('proceed-to-health-benefits', yes);
      // this.$root.$emit('proceed-to-health-benefit-limits', yes);
    },
  },
};
</script>
